Drupal.behaviors.sub_menu_mobile_block = {
  attach: function (context, settings) {
   'use strict';

   // Set 'document' to 'context' if Drupal
   var mobileSubMenuExpand = context.querySelectorAll('.main-sub-menu_mobile__h2');

   // Accordion Toggle
   // Mobile Click Menu Transition
   for (var i = 0; i < mobileSubMenuExpand.length; i++) {
     mobileSubMenuExpand[i].addEventListener('click', function (e) {
       var className = 'is-active';
       // Add is-active class
       if (this.parentNode.classList) {
         this.parentNode.classList.toggle(className);
       }
       else {
         var classes = this.parentNode.className.split(' ');
         var existingIndex = classes.indexOf(className);

         if (existingIndex >= 0) {
           classes.splice(existingIndex, 1);
         }
         else {
           classes.push(className);
         }
         this.parentNode.className = classes.join(' ');
       }
       e.preventDefault();
     });
   }

 }
};
